import { baseApi } from './baseApi';
import type { CommentResponse } from '../types';

const commentsApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getReplies: builder.query<CommentResponse[], { commentId: string }>({
      query: ({ commentId }) => `/comments/comment/replies/${commentId}`,
      extraOptions: { allowAnonymous: true }, // public read (isAuthGet)
      providesTags: (result) =>
        result
          ? [...result.map(({ _id }) => ({ type: 'Replies' as const, id: _id })), 'Replies']
          : ['Replies'],
    }),

    postComment: builder.mutation<CommentResponse, { content: string; questionId: string }>({
      query: ({ content, questionId }) => ({
        url: `/comments/question/${questionId}`,
        method: 'POST',
        body: { content },
      }),
      invalidatesTags: ['Questions'],
    }),

    replyComment: builder.mutation<CommentResponse, { content: string; commentId: string; questionId: string }>({
      query: ({ content, commentId, questionId }) => ({
        url: `/comments/reply/${questionId}/${commentId}`,
        method: 'POST',
        body: { content },
      }),
      invalidatesTags: ['Replies', 'Questions'],
    }),

    answerComment: builder.mutation<CommentResponse, { commentId: string; answer: boolean }>({
      query: ({ commentId, answer }) => ({
        url: `/comments/answer/${commentId}`,
        method: 'POST',
        body: { answer },
      }),
      invalidatesTags: ['Questions', 'Replies'],
    }),
  }),
});

export const {
  useGetRepliesQuery,
  usePostCommentMutation,
  useReplyCommentMutation,
  useAnswerCommentMutation,
} = commentsApi;
